export const DATE_FORMAT = 'd MMM'
export const DATE_FORMAT_WITH_YEARS = 'd MMM yyyy'
export const API_DATE_FORMAT = 'yyyy-MM-dd'

export const CANCEL_MODAL_MIN_HEIGHT_PX = 248
